/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IDohItem {
  itemImage?: string;
  itemText?: string;
  itemHeading?: string;
}

export interface IDohPage extends IDohItem {
  pageHeading?: string;
  pageText?: string;
  itemList: IDohItem[];
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class Bunny extends Component {
  private readonly dohPage: IDohPage = {
    pageHeading: 'Play-Doh Brand How To: make a bunny',
    pageText:
      'Hop to it! A little Play-Doh compound and some creativity make a hippity-hoppity pal in minutes. After you and the little buns finish molding and crafting, add some fun accessories with some more Play-Doh colors! We can think of a few, like a crazy carrot or maybe an Easter egg. Create the bunny using the steps below and see where it takes their imaginations!',

    itemList: [
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZZ7',
        itemText:
          'Our fluffy bunny’s body will require some white Play-Doh compound. Mold some into an oval (or egg) shape, large enough to hold its head and legs. Mold another, smaller oval out of white Play-Doh compound for its head. Stretch two pieces of white Play-Doh compound into two cylinders.',

        itemHeading: 'mold the bunny’s body',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1XsE',
        itemText:
          'Those two white cylinders they made? Let’s roll ’em up three-quarters of their length to make some legs and bunny feet, then stick them to both sides of the larger oval. Mold two shorter cylinders from white Play-Doh compound and stick those just above the rolled-up legs. Take the smaller oval and center it atop the large oval.',
        itemHeading: 'make legs and arms',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1XsF',
        itemText:
          'Let’s take some pink, white and blue Play-Doh compound to make the rest of this bun-bun. Mold floppy ears out of white Play-Doh compound and shape pink Play-Doh compound inside the white ears. Roll two small blue eyes and a pink nose. Place the ears on both side of its head, place the nose just below the center of its face and eyes above the nose.',
        itemHeading: 'ears, eyes and nose',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1UrR',
        itemText:
          'Their cute bunny is complete! Add it to their other Play-Doh compound creations for a new fun partner in play. Show it off, hop along or smush it all up for another creation.',

        itemHeading: 'hare-raising fun!',
      },
    ],
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12'>
            <h1 className='page-heading'>{this.dohPage.pageHeading}</h1>
          </div>
          <div className='col-md-12'>
            <div className='page-text'>
              <p>{this.dohPage.pageText}</p>
            </div>
          </div>
        </div>
        {this.dohPage.itemList.map((item) => (
          <div className='row'>
            <div className='col-md-12'>
              <table className='box'>
                <tr>
                  <td className='box-1'>
                    <img src={item.itemImage} alt={item.itemHeading} />
                  </td>
                  <td className='box-2'>
                    <h1 className='page-heading'>{item.itemHeading}</h1>
                    <p>{item.itemText}</p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        ))}
      </React.Fragment>
    );
  }
}

export default Bunny;
